import { render, staticRenderFns } from "./ProfileEditCreate.vue?vue&type=template&id=2d130d1b&"
import script from "./ProfileEditCreate.vue?vue&type=script&lang=js&"
export * from "./ProfileEditCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports